// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgGoogle: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <path
        fill={primary ?? fill ?? '#4280EF'}
        d="M23.762 12.288c0-.81-.078-1.647-.209-2.432h-11.32v4.628h6.484a5.455 5.455 0 0 1-2.405 3.634l3.869 3.006c2.274-2.117 3.581-5.202 3.581-8.836"
      />
      <path
        fill={secondary ?? fill ?? '#34A353'}
        d="M12.233 24c3.242 0 5.96-1.072 7.948-2.902l-3.87-2.98c-1.071.732-2.457 1.15-4.078 1.15-3.137 0-5.777-2.145-6.745-4.968l-3.974 3.086A11.988 11.988 0 0 0 12.234 24"
      />
      <path
        fill={tertiary ?? fill ?? '#F6B704'}
        d="M5.488 14.3a7.29 7.29 0 0 1 0-4.6L1.514 6.615a12.016 12.016 0 0 0 0 10.77z"
      />
      <path
        fill={quaternary ?? fill ?? '#E54335'}
        d="M12.233 4.759a6.547 6.547 0 0 1 4.601 1.803l3.425-3.45C18.09 1.072 15.213-.026 12.233 0 7.684 0 3.553 2.563 1.514 6.615L5.488 9.7c.968-2.85 3.608-4.941 6.745-4.941"
      />
    </svg>
  );
};

const Memo = memo(SvgGoogle);
export default Memo;
